module.exports = __webpack_public_path__ + "static/media/ost_12.f0a4d8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ost_12.png
// module id = 1039
// module chunks = 0